import React, {ReactNode, ReactElement} from 'react';

import {useExperiments, ExperimentId, VariantId} from 'mkt-ssr/lib/experiments';

export interface ExperimentVariantProps {
  experimentId: ExperimentId;
  variantId: VariantId;
  children: ReactNode;
}

export function ExperimentVariant({
  experimentId,
  variantId,
  children,
}: ExperimentVariantProps): ReactElement | null {
  const {experimentData} = useExperiments();

  const assignedVariant = experimentData[experimentId]?.variant_id ?? 'control';

  return assignedVariant === variantId ? <>{children}</> : null;
}
